import React, { useState } from 'react';
import { HeaderBar, Wrapper, CtaButton, Footer, CARD } from './Shared';
import { track, sendLead, saveLead, getLead, firstName } from './pixel';
import { PRIVACY_URL, TERMS_URL, BRAND } from './config';

// PASO 2: preguntas de filtro, una por pantalla (estilo aplicación). Ya dio sus datos -> alta tasa de finalización.
type Q = {
  key: string;
  q: string;
  options?: string[];
  stopIf?: string;
};
const QUESTIONS: Q[] = [{
  key: 'work_auth',
  q: '¿Tienes autorización para trabajar en Estados Unidos?',
  options: ['Sí', 'No'],
  stopIf: 'No'
},
// Nadie queda fuera por no tener licencia: la mayoría son reclutas nuevos y Chale los guía para sacarla
{
  key: 'license',
  q: '¿Ya tienes licencia de seguros de vida? Si no la tienes, no te preocupes: te guiamos para sacarla.',
  options: ['Ya tengo licencia', 'Todavía no, pero quiero sacarla', 'Todavía no, quiero saber cómo funciona']
}, {
  key: 'hours',
  q: '¿Cuántas horas por semana podrías dedicarle?',
  options: ['Menos de 5', '5 a 10', '10 a 20', 'Más de 20']
}, {
  key: 'why',
  q: 'Última: ¿por qué quieres construir algo propio? Cuéntame en 2 o 3 líneas.'
}];

// Texto exacto del consentimiento: se guarda en GHL junto con la fecha (prueba de consentimiento TCPA / A2P 10DLC)
const CONSENT_TEXT = `Acepto recibir llamadas, mensajes de texto (SMS), WhatsApp y correos de ${BRAND} y su equipo sobre esta solicitud al número que proporcioné, incluso enviados con sistemas automatizados. El consentimiento no es condición de compra. La frecuencia de mensajes varía. Pueden aplicar tarifas de mensajes y datos. Responde STOP para cancelar o HELP para ayuda.`;
export function Qualify({
  onDone
}: {
  onDone: () => void;
}) {
  const [i, setI] = useState(0);
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const [why, setWhy] = useState('');
  const [consent, setConsent] = useState(false);
  const [err, setErr] = useState('');
  const [stopped, setStopped] = useState(false);
  const name = firstName();
  const q = QUESTIONS[i];
  const pct = Math.round((i + 1) / QUESTIONS.length * 100);
  const pick = async (opt: string) => {
    const next = {
      ...answers,
      [q.key]: opt
    };
    setAnswers(next);
    saveLead(next);
    // GUARDADO PROGRESIVO: el contacto ya entró al CRM en el paso 1 (step 'datos').
    // Cada respuesta actualiza ese mismo contacto (mismo email/teléfono), así quedan mapeadas
    // aunque la persona no termine. En GHL: 'aplicacion_estado' = 'incompleta' + 'ultima_pregunta'.
    if (!(q.stopIf && opt === q.stopIf)) {
      sendLead({
        step: 'progreso',
        ...getLead(),
        ...next,
        aplicacion_estado: 'incompleta',
        ultima_pregunta: q.key,
        preguntas_respondidas: `${i + 1} de ${QUESTIONS.length}`
      });
    }
    if (q.stopIf && opt === q.stopIf) {
      setStopped(true);
      await sendLead({
        step: 'no_califica',
        ...getLead(),
        ...next,
        aplicacion_estado: 'no_califica',
        ultima_pregunta: q.key
      });
      return;
    }
    setI(i + 1);
  };
  const finish = async (e: React.FormEvent) => {
    e.preventDefault();
    if (why.trim().length < 20) return setErr('Cuéntame un poquito más (mínimo 20 caracteres).');
    if (!consent) return setErr('Necesito tu autorización para contactarte por WhatsApp.');
    const all = {
      ...answers,
      why,
      consent: true,
      consent_text: CONSENT_TEXT,
      consent_at: new Date().toISOString(),
      consent_page: window.location.href
    };
    saveLead(all);
    await sendLead({
      step: 'aplicacion',
      ...getLead(),
      ...all,
      aplicacion_estado: 'completa',
      preguntas_respondidas: `${QUESTIONS.length} de ${QUESTIONS.length}`
    });
    track('SubmitApplication');
    onDone();
  };
  return <div className="funnel-root bg-white min-h-screen flex flex-col" data-id="element-644" data-mp="10720xqdhx0r6">
      <HeaderBar data-id="element-645" data-mp="v76368ve65k2" />
      <section className="flex-1 pt-10 sm:pt-16 pb-20 sm:pb-24" data-id="element-646" data-mp="v7pg1b66q3r8">
        <Wrapper className="max-w-[760px] text-center" data-id="element-647" data-mp="2uhxk1mmb3y87">
          {!stopped && <>
              <p className="font-semibold text-brand text-[14px] sm:text-[15px]" data-id="element-648" data-mp="2pkx9ozifc9ba">Paso 2 de 2 · Ya casi terminas</p>
              <div className="mt-3 h-2 rounded-full bg-brand-light overflow-hidden" data-id="element-649" data-mp="1n6zfiwoqjglc">
                <div className="h-full rounded-full bg-brand transition-[width] duration-300 ease-out" style={{
              width: `${pct}%`
            }} data-id="element-650" data-mp="1r6rtjowweey3" />
              </div>
              <p className="mt-6 font-bold text-[18px] sm:text-[22px] text-ink [text-wrap:balance]" data-id="element-651" data-mp="1i7efsk1qr47k">{name ? `${name}, ` : ''}respondes {QUESTIONS.length} preguntas rápidas y apartas tu horario.</p>
            </>}

          {stopped ? <div className={`${CARD} mt-4 p-6 sm:p-10 step-in`} data-id="element-652" data-mp="18a0c7l0x29wo">
              <h2 className="font-extrabold tracking-tight text-[24px] sm:text-[32px] leading-tight text-ink" data-id="element-653" data-mp="uic37qlys1jx">Gracias por tu sinceridad{name ? `, ${name}` : ''}.</h2>
              <p className="mt-4 text-[16px] sm:text-[20px] text-gray-700 leading-snug" data-id="element-654" data-mp="zesn28m4rtr7">Por ahora este programa requiere autorización para trabajar en EE.UU. Si tu situación cambia, aquí estaré.</p>
            </div> : <div key={i} className={`${CARD} mt-6 p-6 sm:p-10 text-left step-in`} data-id="element-655" data-mp="5we2cauip7h5">
              <p className="text-[13px] font-semibold text-brand" data-id="element-656" data-mp="1vc2pswouten">Pregunta {i + 1} de {QUESTIONS.length}</p>
              <h2 className="mt-2 font-extrabold tracking-tight text-[22px] sm:text-[30px] leading-tight text-ink" data-id="element-657" data-mp="futw6lkxiuuc">{q.q}</h2>

              {q.options ? <div className="mt-6 grid gap-3" data-id="element-658" data-mp="aupbejczndyb">
                  {q.options.map(o => <button key={o} type="button" onClick={() => pick(o)} className={`w-full rounded-xl border-2 px-5 py-4 sm:py-5 text-left text-[17px] sm:text-[19px] font-semibold transition-colors duration-150 ease-out ${answers[q.key] === o ? 'border-brand bg-brand text-white' : 'border-gray-200 bg-white text-ink hover:border-brand'}`} data-id="element-659" data-mp="ou8gt4ef0b6x">
                      {o}
                    </button>)}
                </div> : <form id="qualForm" onSubmit={finish} className="mt-6 space-y-5" data-id="element-660" data-mp="13lz9ou3edb1h">
                  <textarea value={why} onChange={e => {
              setWhy(e.target.value);
              if (err) setErr('');
            }} placeholder="Quiero construir algo propio porque…" aria-label="¿Por qué quieres construir algo propio?" className="w-full min-h-[140px] rounded-xl border border-gray-200 bg-white px-5 py-4 text-[16px] sm:text-[18px] text-ink outline-none transition-[border-color,box-shadow] duration-150 ease-out focus:border-brand focus:ring-4 focus:ring-brand-light placeholder:text-gray-400" data-id="element-661" data-mp="1aonou29h8csf" />
                  <p className={`-mt-3 text-[13px] ${why.trim().length >= 20 ? 'text-brand font-semibold' : 'text-gray-500'}`} data-id="element-662" data-mp="1ybvr0bblz5q8">
                    {why.trim().length >= 20 ? 'Perfecto, gracias.' : `Mínimo 20 caracteres · llevas ${why.trim().length}`}
                  </p>
                  {/* Casilla NO marcada por defecto: el consentimiento debe ser una acción expresa */}
                  <label className="flex items-start gap-3 text-[13px] sm:text-[14px] leading-relaxed text-gray-600" data-id="element-663" data-mp="dyogo8x8ngad">
                    <input type="checkbox" checked={consent} onChange={e => {
                setConsent(e.target.checked);
                if (err) setErr('');
              }} className="mt-0.5 h-5 w-5 shrink-0" data-id="element-664" data-mp="6fnkk8oroox1" />
                    <span data-id="element-665" data-mp="3ssvwc8w192dz">
                      {CONSENT_TEXT} Consulta la <a href={PRIVACY_URL} className="underline" data-id="element-666" data-mp="3srcdqbmwmf91">Política de Privacidad</a> y los <a href={TERMS_URL} className="underline" data-id="element-667" data-mp="3nw5cdah3xmna">Términos</a>.
                    </span>
                  </label>
                  {err && <p role="alert" className="text-sm font-medium text-red-600" data-id="element-668" data-mp="kdvmyw4koifl">{err}</p>}
                  {/* El botón nombra la recompensa (su lugar con Chale), no la tarea. El sub avisa del video para que no haya sorpresa. */}
                  <CtaButton type="submit" form="qualForm" label="Apartar mi horario con Chale" sub="Último paso · antes, un video corto de Chale" data-id="element-669" data-mp="agh6wxmk9vnt" />
                </form>}

              {i > 0 && <button type="button" onClick={() => setI(i - 1)} className="mt-5 text-[14px] font-medium text-gray-500 underline underline-offset-4" data-id="element-670" data-mp="2v5nd6kji85f5">← Volver</button>}
            </div>}
        </Wrapper>
      </section>
      <Footer data-id="element-671" data-mp="3puqahtiqqdtw" />
    </div>;
}